import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators'

type FileNameResponse = { fileName: string }

@Injectable({ providedIn: 'root' })
export class AhuImageService {
  constructor(private http: HttpClient) {}

  public getAhuImageUrl(imageUrlEndpoint: string) {
    return this.http.get<FileNameResponse>(imageUrlEndpoint).pipe(map(value => `./Api/ahu/ahuImage/${value.fileName}`))
  }

  public updateCacheBusterInImageUrl(currentUrl: string) {
    if (!currentUrl) {
      return currentUrl
    }
    if (currentUrl.includes('decache=')) {
      return currentUrl.replace(/decache=\d+/, `decache=${new Date().valueOf()}`)
    }
    return currentUrl
  }
}
